import Head from 'next/head';
import Appbar from '../components/appBar';
import Footer from "../components/footer";
import WidgetWa from "../components/widgetWa"; 
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';  
import Avatar from '@material-ui/core/Avatar';  
import useStyles from '../styles/aboutCeoStyle';


export default function Director() {

  const classes = useStyles();

  return (
    <> 
      <Head>
        <title>Director</title>
        <link rel="icon" href="/favicon.ico" /> 
        <meta charSet="utf-8" />
        <meta itemProp="description" content="Conozca la dirección de CIDU S.A.S y su experiencia."/>
        <link rel="canonical" href="https://cidu.com.co/director" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>  
      <Grid>
        <Appbar/>
        <Grid >
          <div className={classes.backgroundirector} />
          <Grid container  justify="center" alignItems="center"   className={classes.paperContainer}>
            <Grid item xs={11}>
              <Paper  elevation={7} className={classes.paperContent}>
                <Container maxWidth='md'>
                  <Grid container  justify="center" alignItems="stretch" direction="column"> 
                    <Grid item container  justify="center" alignItems="center" direction="column">
                      <Avatar alt="Jonathan Ortiz" src={"/images/ceo/jonathan.jpeg"} className={classes.avatarImage} imgProps={{ draggable: 'false' }}/>
                    </Grid> 
                    <Typography variant="h4" align="center"   className={classes.cardtittle}>
                      Jonathan Ortiz Castaño
                    </Typography> 
                    <Typography variant="h6" align="center"   className={classes.cardsubtittle}>
                      Ingeniero Catastral y Geodesta, Especialista en avalúos.
                    </Typography>  
                    <Typography variant="h6" align="justify"  component="p"  className={classes.cardtext}>
                    Ingeniero Catastral y Geodesta, Especialista en Avalúos de la Universidad Distrital Francisco José de 
                    Caldas, con diplomado en Normas Internacionales de Contabilidad e Información Financiera NIC-NIIFs con el 
                    Centro Iberoamericano de Estudios Internacionales, cuenta actualmente con el Registro Abierto de Avaluadores – 
                    RAA en las siguientes categorías:
                    </Typography>
                    <Typography variant="h6" align="left" component="div" className={classes.cardtextLeft}>
                      <li>Inmuebles Urbanos</li>
                      <li>Inmuebles Rurales</li>
                      <li>Recursos Naturales y Suelos de Protección</li>
                      <li>Obras de Infraestructura</li>
                      <li>Edificaciones de Conservación Arqueológica y Monumentos Históricos </li>
                      <li>Inmuebles Especiales</li>
                      <li>Maquinaria Fija, Equipos y Maquinaria Móvil</li>
                      <li>Maquinaria y Equipos Especiales</li>
                      <li>Obras de Arte, Orfebrería, Patrimoniales y Similares</li>
                      <li>Semovientes y Animales</li>
                      <li>Activos Operacionales y Establecimientos de Comercio</li>
                      <li>Intangibles</li>
                      <li>Intangibles Especiales</li>
                    </Typography>
                    <Typography variant="h6" align="justify"  component="p" className={classes.cardtext}>
                        Adicionalmente cuenta con amplios conocimientos en la actividad catastral del país reflejados en la experiencia laboral 
                        en el Unidad Administrativa Especial de Catastro Distrital donde formuló y presentó la aplicación metodológica para la 
                        determinación de valores comerciales de inmuebles especiales con clasificación de suelo protegido, plan parcial, uso dotacional, 
                        al igual que la formulación de macros para el cálculo masivo de la Plusvalía para el Distrito Capital, entre otros; al igual 
                        cuenta con experiencia en el Instituto Geográfico Agustín Codazzi, participando en todas las etapas de procesos avalúos comerciales 
                        y en la determinación del Índice de Valoración Predial (IVP).
                    </Typography>
                    <Typography variant="h6" align="justify"  component="p" className={classes.cardtext}>
                        En el ámbito privado ha realizado la ejecución y coordinación de proyectos de valoración de inmuebles y activos 
                        de entidades financieras como BBVA, Colpatria, BCSC, al igual que la coordinación técnica en proyectos de valoración 
                        inmobiliaria para entidades de orden nacional como Covinoc, UT GASA en convenio con la Dirección Nacional de Estupefacientes 
                        y la Sociedad de Activos Especiales, entre otras.
                    </Typography>
                    <Typography variant="h6" align="justify"  component="p" className={classes.cardtext}>
                        Ha participado en la investigación de los Estudios del valor del suelo rural de la sabana de Bogotá y urbano en la ciudad de 
                        Bogotá, con la Lonja de Propiedad Raíz de Bogotá. Mejoramiento y Desarrollo de Metodologías de Avalúos Masivos y Plusvalía con 
                        Catastro Distrital. 
                    </Typography>
                    <Typography variant="h6" align="justify"  component="p" className={classes.cardtext}>
                        Docente y conferencista con la Universidad nacional de Colombia – Facultad de Ingeniería, Lonja de 
                        Propiedad Raíz de Bogotá y EDUAMERICA, Conferencista de Metodologías de Valoración al interior Catastro Distrital, entre otros.
                    </Typography>
                  </Grid>
                </Container>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <Footer/>
      </Grid>
      <WidgetWa link={"https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!"}/>
    </>
  );
}

